import { TypedDocumentNode } from '@apollo/client'
import { useQuery } from '@apollo/client/react'
import { ReceptionStatusBaseQueryDocument } from '@docpace/reception-status-graphql/dist/urql.types'
import { ReceptionStatusBaseQueryResultFragment } from '@docpace/reception-status-graphql'

const typedReceptionStatusBaseQueryDocument = ReceptionStatusBaseQueryDocument as TypedDocumentNode<ReceptionStatusBaseQueryResultFragment>

export function useReceptionStatusBaseQuery(opts?: useQuery.Options<ReceptionStatusBaseQueryResultFragment>){
    return useQuery(typedReceptionStatusBaseQueryDocument, opts)
}
